import CertQuery from '../CertQuery';
export default {
  components: {
    CertQuery: CertQuery
  }
};